var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tabs",
    {
      staticClass: "order-wrapper",
      attrs: { type: "border-card" },
      on: { "tab-click": _vm.handleClick },
      model: {
        value: _vm.ruleForm.activeName,
        callback: function($$v) {
          _vm.$set(_vm.ruleForm, "activeName", $$v)
        },
        expression: "ruleForm.activeName"
      }
    },
    _vm._l(_vm.tabsArr, function(item, index) {
      return (!_vm.isNewOrder && index === 0) || _vm.isNewOrder
        ? _c(
            "el-tab-pane",
            {
              key: index,
              attrs: { label: item.label, name: index.toString(), lazy: true }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.tableLoading,
                      expression: "tableLoading"
                    }
                  ],
                  staticClass: "table-wrapper"
                },
                [
                  _c(
                    "el-table",
                    {
                      staticClass: "table-wrapper-table",
                      staticStyle: { width: "100%" },
                      attrs: { data: _vm.tableData, border: "" }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          fixed: "left",
                          align: "center",
                          prop: "status",
                          label: "操作"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "link-url",
                                      on: {
                                        click: function($event) {
                                          return _vm.goDetail(scope.row)
                                        }
                                      }
                                    },
                                    [_vm._v("详情")]
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "status",
                          label: "状态"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm._f("statusFormat")(scope.row.status)
                                      ) +
                                      "\n          "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "orderNo",
                          label: "订单号",
                          width: "220"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { align: "center", prop: "name", label: "货物" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(scope.row.goodsName[0]) +
                                      "\n          "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "totalMoney",
                          label: "运费",
                          width: "100"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "totalWeight",
                          label: "吨位",
                          width: "100"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "createTime",
                          label: "创建时间",
                          width: "160"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm._f("timeFormat")(
                                          scope.row.createTime
                                        )
                                      ) +
                                      "\n          "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "deliverTime",
                          label: "预提时间",
                          width: "160"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm._f("timeFormat")(
                                          scope.row.deliverTime
                                        )
                                      ) +
                                      "\n          "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "completeTime",
                          label: "确认送达时间",
                          width: "160"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm._f("timeFormat")(
                                          scope.row.completeTime
                                        )
                                      ) +
                                      "\n          "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "plateNo",
                          label: "车号",
                          width: "160"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        scope.row.truck
                                          ? scope.row.truck[0].plateNo
                                          : ""
                                      ) +
                                      "\n          "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "city_from",
                          label: "起点",
                          "show-overflow-tooltip": "",
                          width: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "city_to",
                          label: "终点",
                          "show-overflow-tooltip": "",
                          width: "140"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "billing",
                          label: "是否开票"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        scope.row.billing === 1 ? "是" : "否"
                                      ) +
                                      "\n          "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          prop: "sbustitude",
                          label: "是否货到付款",
                          width: "120"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        scope.row.sbustitude === 1 ? "是" : "否"
                                      ) +
                                      "\n          "
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "table-page-wrapper" },
                    [
                      _c("el-pagination", {
                        attrs: {
                          layout: "prev, pager, next",
                          total: _vm.total,
                          "hide-on-single-page": true
                        },
                        on: { "current-change": _vm.currentChange }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        : _vm._e()
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-425f8946", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-425f8946","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/order/components/orderTable/index.vue
// module id = null
// module chunks = 